/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseStatus } from '../../models/base-status';
import { DailyLineAccessResponse } from '../../models/daily-line-access-response';

export interface GetDailyLineAccess$Params {

/**
 * Optional. Omit = Active and Inactive Bases. Filters rotorWing.bases only.
 */
  status?: BaseStatus;
}

export function getDailyLineAccess(http: HttpClient, rootUrl: string, params?: GetDailyLineAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<DailyLineAccessResponse>> {
  const rb = new RequestBuilder(rootUrl, getDailyLineAccess.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DailyLineAccessResponse>;
    })
  );
}

getDailyLineAccess.PATH = '/api/scheduler/daily-line-schedule/access';
